import _defineProperty from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genStyleHooks, mergeToken } from '../../theme/internal';
import { initComponentToken, initInputToken } from './token';
// =============================== OTP ================================
var genOTPStyle = function genOTPStyle(token) {
  var componentCls = token.componentCls,
    paddingXS = token.paddingXS;
  return _defineProperty({}, "".concat(componentCls), _defineProperty(_defineProperty(_defineProperty({
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    columnGap: paddingXS,
    '&-rtl': {
      direction: 'rtl'
    }
  }, "".concat(componentCls, "-input"), {
    textAlign: 'center',
    paddingInline: token.paddingXXS
  }), "&".concat(componentCls, "-sm ").concat(componentCls, "-input"), {
    paddingInline: token.calc(token.paddingXXS).div(2).equal()
  }), "&".concat(componentCls, "-lg ").concat(componentCls, "-input"), {
    paddingInline: token.paddingXS
  }));
};
// ============================== Export ==============================
export default genStyleHooks(['Input', 'OTP'], function (token) {
  var inputToken = mergeToken(token, initInputToken(token));
  return [genOTPStyle(inputToken)];
}, initComponentToken);